import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CombinationPageOptions } from "../Constants/RegistrationPageOptions";
import EventCardList from "./EventCardList";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import DateHelpers from "../Helper/DateHelpers";
import InputValidation from "../Helper/InputValidation";
import DataAccessHelper from "../Helper/DataAccessHelper";
import { getAttendeeCount, getRegistrationFeeDue } from "../Constants/RetreatConfig";
import '../Styles/DayCampRegistrationPayment.scss';

const stripePromise = loadStripe("pk_live_51Qj8NvRstlwNU15E4RDarYStMSEcfHxbadUFqI9kSoC2Ux263Q9MNwMSVwFVhPLMxYWzD6R5MZDH2Eet5lG6afAY00VDLdBkCa")

function IndividualRegistrationPayment({ account, week, validateAndProcessRegistration,
   amountDue, setAmountDue, paymentAmount, setPaymentAmount, paymentType, setPaymentType,
   promoCode, setPromoCode, groupJoined, ProcessRegistration, roomSurcharge = 0,
   sonSurcharge = 0, sonCount = 0, setSelectedPage, previousPage }) {

   // The surcharges default to 0 so the overnight camp flow, which passes neither, is unaffected.
   const entireAmount = Number(week.registration_fee) + Number(week.camp_fee) + roomSurcharge + sonSurcharge

   // Both fees are per person. Only the Father and Son Adventure registers more than one person on
   // a single record, so everywhere else these come out to the plain event-row figures.
   const attendeeCount = getAttendeeCount(week, sonCount)
   const registrationFeeDue = getRegistrationFeeDue(week, sonCount)

      console.log("Week! at the top of the payment form", week)

   const [paymentIntent, setPaymentIntent] = useState({})
   const [unprocessedPaymentIntentId, setUnprocessedPaymentIntentId] = useState()
   const [customerId, setCustomerId] = useState("")
   const [clientSecret, setClientSecret] = useState("")
   const options = { clientSecret }
   const [paymentInformationVisibility, setPaymentInformationVisibility] = useState(false)
   const [isProcessingPayment, setIsProcessingPayment] = useState(false)

   const [promoInputCode, setPromoInputCode] = useState('')
   const [promoMessage, setPromoMessage] = useState('')
   const [promoSearched, setPromoSearched] = useState(false)
   const [selectedPaymentOption, setSelectedPaymentOption] = useState(null)

   // What the Stripe dashboard's description is built from, e.g. "Junior Camp Week 2, 2026 (Registration Fee)".
   const stripeDescriptionDetails = {
      event: { camp_type: week.camp_type, camp_name: week.camp_name, week_num: week.week_num, begin_date: week.begin_date },
      paymentOption: selectedPaymentOption,
   }

   const fetchCustomer = async () => {
      let stripeCustomerId = await registerForEvent()
      console.log("Stripe customer id to be passed to the payment intent", stripeCustomerId)
      console.log("visibility", paymentInformationVisibility)

      if (stripeCustomerId != customerId) {
         setCustomerId(stripeCustomerId)
         console.log("Setting the customer id state for the first time.")
      }
      else if (!clientSecret) {
         console.log("Customer id already set but no client secret — creating new payment intent")
         let totalDue = paymentAmount * 100
         let secret = await createPaymentIntent(stripeCustomerId, totalDue)
         setClientSecret(secret.clientSecret)
      }
      else {
         console.log("Customer id state already set. Update the payment intent price")
         updatePaymentIntent()
      }
   };

   async function registerForEvent() {
      let userEmail = account.email_address
      console.log(userEmail, "Here is the user email")
      var response = await fetch('api/createcustomer', {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({ email: userEmail, name: `${account.first_name ?? ''} ${account.last_name ?? ''}`.trim() }),
      });

      const data = await response.json();
      console.log('Stripe Customer ID:', data.stripeCustomerId);
      return data.stripeCustomerId;
   }

   const createPaymentIntent = async (customer_id, price) => {
      console.log(customer_id, "CUSTOMER_ID to be passed down to payment intent!")
      var response = await fetch('api/create-payment-intent', {
         method: 'POST',
         headers: { 'Content-type': 'application/json' },
         body: JSON.stringify({ customerId: customer_id, price: price, ...stripeDescriptionDetails })
      })

      const data = await response.json();
      console.log("data returned from payment intent", data)
      console.log('The Created Payment Intent: ', data.paymentIntentInfo)
      var clientSecretAndId = data.paymentIntentInfo;
      setUnprocessedPaymentIntentId(clientSecretAndId.id)
      return { clientSecret: clientSecretAndId.clientSecret, id: clientSecretAndId.id };
   }

   const updatePaymentIntent = async () => {
      console.log("Unprocessed Payment Intent Id to be updated", unprocessedPaymentIntentId)
      console.log("Updated payment amount", paymentAmount)
      let totalDue = (paymentAmount * 100)
      var response = await fetch('api/update-payment-intent', {
         method: 'POST',
         headers: { 'Content-type': 'application/json' },
         body: JSON.stringify({ paymentIntentId: unprocessedPaymentIntentId, price: totalDue, ...stripeDescriptionDetails })
      })
   }

   const HandlePayment = async () => {
      try {
         const verified = await validateAndProcessRegistration(paymentIntent.id);
         if (!verified) {
            setIsProcessingPayment(false);
         }
      }
      catch {
         console.error("Stripe did not confirm payment");
         setIsProcessingPayment(false);
      }
   };

   useEffect(() => {
      if (!paymentAmount) {
         return
      }
      console.log("payment amount changed!")
      setPaymentInformationVisibility(true)
      console.log("payment amount", paymentAmount)
      fetchCustomer();
   }, [paymentAmount])

   useEffect(() => {
      const fetchPaymentIntent = async () => {
         if (!customerId) return;
         let totalDue = (paymentAmount * 100)
         console.log("totalDue", totalDue)
         let secret = await createPaymentIntent(customerId, totalDue);
         console.log("Received Client Secret:", secret.clientSecret)
         setClientSecret(secret.clientSecret)
      }
      fetchPaymentIntent();
   }, [customerId])

   useEffect(() => {
      if (!paymentIntent?.id) {
         return
      }
      console.log("payment Intent!!", paymentIntent)
      console.log("status", paymentIntent.status)
      HandlePayment()
   }, [paymentIntent])

   useEffect(() => {
      if (!amountDue) {
         return
      }
      console.log("payment Intent!!", paymentIntent)
      console.log("status", paymentIntent.status)
      console.log("amount due", amountDue)
      setPaymentType('Credit')
   }, [amountDue])

   async function searchPromoCode(event) {
      event.preventDefault()
      try {
         const response = await fetch('/searchpromocode', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ promoCode: promoInputCode, groupJoined })
         })
         const result = await response.json()
         const data = result.data

         if (data.type === 'promo_code') {
            if (data.discountType === 'FLAT') {
               setPromoCode({ isSelected: true, promoSelected: 'promo_code', promoType: 'promo_code', discountPercent: 0, discountAmount: data.discount, promoId: data.promoId })
               setPromoMessage(`Promo code applied! $${data.discount} off your registration.`)
               setPromoSearched(true)
               if (selectedPaymentOption) {
                  const base = selectedPaymentOption === 'reg_fee'
                     ? registrationFeeDue
                     : entireAmount
                  setPaymentAmount(parseFloat(Math.max(0, base - data.discount).toFixed(2)))
               }
            } else {
               setPromoCode({ isSelected: true, promoSelected: 'promo_code', promoType: 'promo_code', discountPercent: data.discount, promoId: data.promoId })
               setPromoMessage(data.discount === 100 ? 'Promo code applied! Your camp is completely free.' : `Promo code applied! ${data.discount}% off your registration.`)
               setPromoSearched(true)
               if (selectedPaymentOption && data.discount < 100) {
                  const base = selectedPaymentOption === 'reg_fee'
                     ? registrationFeeDue
                     : entireAmount
                  setPaymentAmount(parseFloat((base * (1 - data.discount / 100)).toFixed(2)))
               }
            }
         } else if (data.type === 'fast_track') {
            setPromoCode({ isSelected: true, promoSelected: data.promoSelected, promoType: 'fast_track', discountPercent: 100, promoId: null })
            setPromoMessage('Promo code applied! Your camp is completely free.')
            setPromoSearched(true)
         } else if (data.type === 'public_marketing') {
            setPromoCode({ isSelected: true, promoSelected: 'public_marketing', promoType: 'public_marketing', discountPercent: 0, discountAmount: data.discount, promoId: null })
            setPromoMessage(`Promo code applied! $${data.discount} off your registration.`)
            setPromoSearched(true)
            if (selectedPaymentOption) {
               const base = selectedPaymentOption === 'reg_fee'
                  ? registrationFeeDue
                  : entireAmount
               setPaymentAmount(parseFloat(Math.max(0, base - data.discount).toFixed(2)))
            }
         } else {
            setPromoCode({ isSelected: false, promoSelected: '', promoType: null, discountPercent: 0, promoId: null })
            setPromoMessage('Invalid promo code. Please try again.')
            setPromoSearched(false)
         }
      } catch (error) {
         console.log(error)
      }
   }

   const isFreecamp = promoCode.isSelected && promoCode.discountPercent === 100
   const hasPartialDiscount = promoCode.isSelected && ((promoCode.discountPercent > 0 && promoCode.discountPercent < 100) || promoCode.discountAmount > 0)

   return (
      <div className="DayCampRegistrationPaymentContent">
         <div className="DayCampRegistrationPaymentHeading">
            Payment
         </div>
         <div className="DayCampRegistrationPaymentInformation">
            <div className="DayCampRegistrationPaymentSelectedOptions">
               {/* Both fees are per person, so a registration covering a father and his sons shows the
                   head count on each line. A one-person registration keeps the original wording. */}
               <div className="DayCampRegistrationPaymentSelectedWeekRegistFee">
                  <div>
                     Registration Fee{attendeeCount > 1 && ` (${attendeeCount} × $${Number(week.registration_fee).toFixed(2)})`}:
                  </div>
                  <div>
                     ${(Number(week.registration_fee) * attendeeCount).toFixed(2)}
                  </div>
               </div>
               <div className="DayCampRegistrationPaymentSelectedWeekCampFee">
                  <div>
                     Camp Fee{attendeeCount > 1 && ` (${attendeeCount} × $${Number(week.camp_fee).toFixed(2)})`}:
                  </div>
                  <div>
                     ${(Number(week.camp_fee) * attendeeCount).toFixed(2)}
                  </div>
               </div>
               {roomSurcharge > 0 && (
                  <div className="DayCampRegistrationPaymentRoomUpgrade">
                     <div>
                        Room Upgrade (Deluxe):
                     </div>
                     <div>
                        +${roomSurcharge.toFixed(2)}
                     </div>
                  </div>
               )}
               {/* The sons used to get their own surcharge line. They are counted into the two fee lines
                   above now, so repeating them here would read as a second charge for the same boys. */}
               {sonCount > 0 && (
                  <div className="DayCampRegistrationPaymentSonFee">
                     <div>
                        Includes:
                     </div>
                     <div>
                        You + {sonCount} {sonCount === 1 ? 'son' : 'sons'}
                     </div>
                  </div>
               )}
               {hasPartialDiscount && (
                  <div className="DayCampRegistrationPaymentPromoDiscount">
                     <div>
                        Promo Discount:
                     </div>
                     <div>
                        {promoCode.discountAmount > 0 ? `-$${promoCode.discountAmount}` : `-${promoCode.discountPercent}%`}
                     </div>
                  </div>
               )}
            </div>

            {/* Promo code input — shown upfront before payment selection */}
            <div className="DayCampRegistrationPromoCodeInput">
               <div className="DayCampRegistrationPromoCodeControls">
                  <input
                     type="text"
                     placeholder="Enter promo code"
                     value={promoInputCode}
                     onChange={(e) => setPromoInputCode(e.target.value)}
                     disabled={promoSearched && promoCode.isSelected}
                  />
                  <button
                     onClick={searchPromoCode}
                     disabled={promoSearched && promoCode.isSelected}>
                     Apply
                  </button>
                  {promoSearched && promoCode.isSelected && (
                     <button onClick={() => {
                        setPromoCode({ isSelected: false, promoSelected: '', promoType: null, discountPercent: 0, discountAmount: 0, promoId: null })
                        setPromoInputCode('')
                        setPromoMessage('')
                        setPromoSearched(false)
                        setPaymentAmount(0)
                        setPaymentInformationVisibility(false)
                        setClientSecret('')
                        setSelectedPaymentOption(null)
                     }}>
                        Remove
                     </button>
                  )}
               </div>
               {promoMessage && (
                  <div className="DayCampRegistrationPromoCodeMessage" style={{ color: promoCode.isSelected ? "green" : "red" }}>
                     {promoMessage}
                  </div>
               )}
            </div>

            {/* 100% off (fast track or full promo): bypass Stripe entirely */}
            {isFreecamp ? (
               <div className="DayCampRegistrationFreecamp">
                  <p>Your promo code covers the full cost of camp. No payment is required.</p>
                  <button onClick={() => ProcessRegistration()}>
                     Complete Registration
                  </button>
               </div>
            ) : (
               <>
                  {/*
                   * EDGE CASE — Partial promo codes and payment selection:
                   * A percentage-based promo is applied to whichever payment option the user selects.
                   * This means "Pay Entire Amount" yields a greater absolute dollar savings than
                   * "Registration Fee Only" because the discount applies to a larger base amount.
                   *
                   * Additionally, the promo is consumed on submission and does NOT carry over to any
                   * future partial payment. If a user selects "Registration Fee Only" with a promo,
                   * the remaining camp fee will be charged at full price when paid later.
                   *
                   * This is intentional for simplicity. Secretaries should be aware that users with
                   * percentage-based codes will almost always prefer "Pay Entire Amount" to maximize
                   * their savings, and that partial-payment + promo combinations do not persist.
                   */}
                  <div className="DayCampRegistrationPaymentPaymentOptionButtons">
                     <button onClick={() => {
                        setSelectedPaymentOption('reg_fee')
                        const regFee = registrationFeeDue
                        const amount = hasPartialDiscount
                           ? promoCode.discountAmount > 0
                              ? parseFloat(Math.max(0, regFee - promoCode.discountAmount).toFixed(2))
                              : parseFloat((regFee * (1 - promoCode.discountPercent / 100)).toFixed(2))
                           : regFee
                        setPaymentAmount(amount)
                     }}>
                        Registration Fee Only (${registrationFeeDue.toFixed(2)})
                     </button>
                     <button onClick={() => {
                        setSelectedPaymentOption('entire')
                        const total = entireAmount
                        const amount = hasPartialDiscount
                           ? promoCode.discountAmount > 0
                              ? parseFloat(Math.max(0, total - promoCode.discountAmount).toFixed(2))
                              : parseFloat((total * (1 - promoCode.discountPercent / 100)).toFixed(2))
                           : total
                        setPaymentAmount(amount)
                        setPaymentInformationVisibility(true)
                     }}>
                        Pay Entire Amount (${entireAmount.toFixed(2)})
                     </button>
                  </div>
                  {paymentInformationVisibility &&
                     <div className="DayCampRegistrationPaymentPaymentInformation">
                        <div className="DayCampRegistrationPaymentPaymentInformationAmount">
                           Payment Amount: ${Number(paymentAmount).toFixed(2)}
                        </div>
                        {clientSecret && (
                           <Elements stripe={stripePromise} options={options}>
                              <CheckoutForm
                                 setPaymentIntent={setPaymentIntent}
                                 onProcessingChange={setIsProcessingPayment} />
                           </Elements>
                        )}
                     </div>
                  }
               </>
            )}
         </div>
         {!isProcessingPayment &&
            <div className="DayCampRegistrationPaymentButtonsContainer">
               <div className="DayCampRegistrationPaymentButtons">
                  <div className="DayCampRegistrationPaymentPreviousButton">
                     <button onClick={() => setSelectedPage(previousPage)}>
                        Previous
                     </button>
                  </div>
               </div>
            </div>
         }
      </div>
   )
} export default IndividualRegistrationPayment
